import InfoIcon from '@mui/icons-material/Info';
import { Stack, Typography } from '@mui/material';
import { green, red } from '@mui/material/colors';

export function ScoreAccuracy({ test, dataSet }) {
  const displayVal = (val, prefix) => {
    if (!val) {
      return <InfoIcon />;
    }
    const color = {
      color: val.startsWith('T') ? green[500] : red[500],
      '&:hover': {
        cursor: 'pointer',
      },
    };

    return (
      <Typography cursor="pointer" sx={color}>
        {prefix ? `${prefix}${val}` : val}
      </Typography>
    );
  };

  const displaySide = (val) => {
    if (val == null) {
      return '';
    }

    const color = {
      color: val ? green[500] : red[500],
      '&:hover': {
        cursor: 'pointer',
      },
    };
    return (
      <Typography cursor="pointer" sx={color}>
        {val ? '' : 'Wrong side'}
      </Typography>
    );
  };

  return (
    <>
      {dataSet?.dataSetType === 'FACE' && (
        <Stack direction="row" spacing={1}>
          {displayVal(test?.model1Evaluation?.facialAsymetryStatus)}
          {displaySide(test?.model1Evaluation?.facialAsymetrySideCorrect)}
        </Stack>
      )}

      {dataSet?.dataSetType === 'SPEECH' && displayVal(test?.model1Evaluation?.speechStatus)}

      {dataSet?.dataSetType === 'ARMS' && (
        <Stack direction="row" spacing={1}>
          {displayVal(test?.model1Evaluation?.armWeaknessStatus)}
          {displayVal(test?.model1Evaluation?.leftArmWeaknessStatus, 'L-')}
          {displayVal(test?.model1Evaluation?.rightArmWeaknessStatus, 'R-')}
        </Stack>
      )}
    </>
  );
}
